<obg-m-multi-deposit-limit-container
	(navigate)="onNavigate()"
	navigateToReturnUrl
	autoFocusDisabled
	collapseDepositInfo
	newLoginFlow
	hideDepositLimitCalculatorBanner
>
</obg-m-multi-deposit-limit-container>
